import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "izitoast-react/dist/iziToast.css";
import App from "./App";
import { loadConfig } from "./config/Config";
import LayoutSkeleton from "./components/layoutSkeleton/LayoutSkeleton";

const root = createRoot(document.getElementById("root")!);

function RootApp() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadConfig().then(() => setReady(true));
  }, []);

  if (!ready) return <LayoutSkeleton />;

  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

root.render(<RootApp />);
